<header class="topbar" [class.sticky]="isScrolled && stickyBar" [style]="'height:' + height + 'px'">
    <div class="hamburger-menu" *ngIf="mobileMenu || false">
        <p-button icon="pi pi-bars" iconPos="left" [outlined]="true" (onClick)="toogleMobileMenu();" />
        <img [src]="logo" routerLink="homeRoute" class="home-logo" [style]="'height:' + (height - imageVerticalGap) + 'px'" *ngIf="logo" />
        <div class="mobile-menu {{isMobileMenuOpen ? 'open' : ''}}">
            <a *ngFor="let item of mobileMenuList" (click)="onMobileMenuItemClick(item)"><i class="{{item.icon}}" *ngIf="item.icon"></i><span>{{item.label}}</span></a>
        </div>
    </div>
  <div class="topbar-left-side">
    <ng-container *ngIf="leftTemplateBefore">
      <ng-container *ngTemplateOutlet="leftTemplateBefore"></ng-container>
    </ng-container>
    <img
      [src]="logo"
      routerLink="homeRoute"
      class="home-logo"
      [style]="'height:' + (height - imageVerticalGap) + 'px'"
      *ngIf="logo"
    />
    <h1 *ngIf="title" style="color: white">{{ title }}</h1>
    <ng-container *ngIf="leftTemplateAfter">
      <ng-container *ngTemplateOutlet="leftTemplateAfter"></ng-container>
    </ng-container>
  </div>
  <div class="topbar-right-side">
    <ng-container *ngIf="rightTemplateBefore">
      <div class="topbar-item">
        <ng-container *ngTemplateOutlet="rightTemplateBefore"></ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="topbarItems">
      <div
        class="topbar-item {{ topbarItem.itemType && topbarItem.itemType === 'input' ? 'input-field' : '' }}"
        *ngFor="let topbarItem of topbarItems.items; let i = index"
      >
        <ng-container *ngIf="!topbarItem.itemType || topbarItem.itemType === 'button'">
          <span *ngIf="topbarItem.spinningBorder" class="spinning-border-background"></span>
          <span *ngIf="topbarItem.spinningBorder" class="spinning-border-mask"></span>
          <p-button
            [icon]="topbarItem?.icon"
            [label]="topbarItem.label"
            [iconPos]="topbarItem.iconPosition"
            [badge]="topbarItem.badge"
            [badgeSeverity]="topbarItem.badgeSeverity || 'contrast'"
            [severity]="topbarItem.severity"
            [outlined]="topbarItem.outlined"
            [styleClass]="getStyleClass(topbarItem, topbarItems)"
            (onClick)="topbarItem?.command()"
          ></p-button>
        </ng-container>
        <ng-container *ngIf="topbarItem.itemType && topbarItem.itemType === 'input'">
          <p-floatlabel variant="on">
            <p-iconfield>
              <p-inputicon
                class="{{ topbarItem.icon }}"
                *ngIf="topbarItem.iconPosition && topbarItem.iconPosition === 'left'"
              />
              <input
                pInputText
                id="in_label_{{ i }}"
                autocomplete="off"
                (change)="topbarItem?.command()"
                class="input-{{ topbarItems.itemsSize }}"
              />
            </p-iconfield>
            <label for="in_label_{{ i }}">{{ topbarItem?.label }}</label>
          </p-floatlabel>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="rightTemplateAfter">
      <div class="topbar-item">
        <ng-container *ngTemplateOutlet="rightTemplateAfter"></ng-container>
      </div>
    </ng-container>
  </div>
</header>
